export default "__VITE_ASSET__CtEbTo8N__"